module.exports = __webpack_public_path__ + "static/media/Calculator.3aaf28c2.PNG";